import { ActivityIndicator, Dimensions, Image, PixelRatio, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours'
import socketConfig from '../../utils/socketConfig'
import CheckCircleIcon from '../../icons/CheckCircleIcon'
import useAuth from '../../hooks/useAuth'
import CrossIcon from '../../icons/CrossIcon'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const VerifiedCustomer = ({ hideScreen, setHasDva }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [accountName, setAccountName] = useState('')
    const [accountNumber, setAccountNumber] = useState('')
    const [setUpError, setSetUpError] = useState('')

    const { email } = useAuth()

    const axiosPrivate = useAxiosPrivate()

    // useEffect(() => {
    //     // Connect to the WebSocket server
    //     const socket = new WebSocket(socketConfig.WEBSOCKET_URL)

    //     // Event listener for successful connection
    //     socket.onopen = () => {
    //         //console.log('WebSocket connected')
    //         //setIsConnected(true)
    //     }

    //     // Event listener for receiving messages
    //     socket.onmessage = (event) => {
    //         //console.log('We are here now!!!!....')
    //         const message = JSON.parse(event.data)
    //         //console.log('Message from server:', message)
    //         //console.log('Email from Message Server:', message?.email)

    //         if (message.email === email) {
    //             setIsLoading(false)

    //             if (message.hasDVA) {
    //                 Toast.show({
    //                     type: 'success',
    //                     text1: 'Success',
    //                     text2: 'Your account is transaction ready!',
    //                 });
    //                 setHasDva(message.hasDVA)
    //                 setAccountName(message.dvaDetails.accountName)
    //                 setAccountNumber(message.dvaDetails.accountNumber)

    //             } else {
    //                 Toast.show({
    //                     type: 'error',
    //                     text1: 'Set-up Error',
    //                     text2: 'Wallet setup failed',
    //                 });
    //                 setSetUpError("Wallet setup failed")
    //             }
    //         } else {
    //             //console.log('Message not relevant to current user.');
    //             setIsLoading(false)

    //             Toast.show({
    //                 type: 'error',
    //                 text1: 'Data Error!',
    //                 text2: 'Wallet set up failed.',
    //             });
    //         }
    //     }

    //     // Event listener for connection close
    //     socket.onclose = () => {
    //         //console.log('WebSocket disconnected')
    //         setIsConnected(false)
    //     }

    //     // Event listener for errors
    //     socket.onerror = (error) => {
    //         //console.error('WebSocket error:', error)
    //     }

    //     // Clean up when component unmounts
    //     return () => {
    //         socket.close();
    //         socket.onopen = null;
    //         socket.onclose = null;
    //         socket.onerror = null;
    //     }
    // }, [])

    const generateDedicatedVirtualAccount = async () => {

        setIsLoading(true)

        try {
            const response = await axiosPrivate.post('/createDVA/generateDVA', { email });
            if (response.status === 200 || response.status === 201) {
                //console.log('Customer DVA Data:', response.data.dvaDetails);
                setAccountName(response.data.dvaDetails.account_name)
                setAccountNumber(response.data.dvaDetails.account_number)
                setHasDva(response.data.hasDVA)

            } else {
                //console.error('Unexpected response:', response.data);
                setSetUpError(error.response.data)
            }

        } catch (error) {
            if (error.response) {
                setSetUpError(error.response.data?.message || 'Server returned an error');
                //console.log(error.response.data?.message)
            } else if (error.request) {
                setSetUpError('No response received from server');
            } else {
                setSetUpError(error.message || 'Error setting up the request');
            }
        }

        finally {
            setIsLoading(false);
        }
    };

    const handleSetHasDVAStatusAgain = async () => {
        setIsLoading(true);

        try {
            const response = await axiosPrivate.post('/hasDVAStatusAgain/hasDVAStatusAgain', { email });

            if (response.status === 200 || response.status === 201) {
                //console.log('DVA Message?:', response.data.message);
                //console.log('hasDVA??:', response.data.hasDVA);
                hideScreen()

            } else {
                //console.error('Unexpected response:', response.data);
                setSetUpError(response.data?.message || 'Unexpected response from server');
            }

        } catch (error) {
            if (error.response) {
                setSetUpError(error.response.data?.message || 'Server returned an error');
            } else if (error.request) {
                setSetUpError('No response received from server');
            } else {
                setSetUpError(error.message || 'Error setting up the request');
            }
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <View style={styles.profileContainer2}>
            <View style={styles.profileHeaderContainer2}>

                {accountName && accountNumber ? <><CheckCircleIcon height={100} width={100} color={Colours.PRIMARY} />
                    <View style={styles.accDetails}>
                        <Text style={{ marginTop: dynamicSpacing(3), color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Medium' }}>
                            Here is your account details for your wallet. Click "Done" to close this page then click on "Wallet" again to access your fully setup wallet account</Text>
                        <Text style={{ marginTop: dynamicSpacing(8), color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>
                            Acc Name {accountName}</Text>
                        <Text style={{ marginTop: dynamicSpacing(3), color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>
                            Acc No.  {accountNumber}</Text>
                    </View>

                    <TouchableOpacity style={styles.button2}
                        onPress={hideScreen}
                    >
                        {isLoading ? (
                            <ActivityIndicator size="small" color="white" />
                        ) : (
                            <Text style={{ fontSize: dynamicFontSize(15), color: 'white', fontFamily: 'Sen-Bold' }}>
                                Done
                            </Text>
                        )}
                    </TouchableOpacity>
                </> :
                    setUpError ? <><CrossIcon height={dynamicSize(100)} width={dynamicSize(100)} color={Colours.PRIMARY} />
                        <Text style={{ marginTop: dynamicSpacing(15), color: Colours.DARKGRAY, fontSize: dynamicFontSize(17), fontFamily: 'Sen-Medium', textAlign: 'center' }}>
                            {setUpError}</Text>
                        <TouchableOpacity style={styles.button2}
                            onPress={hideScreen}
                        >
                            {isLoading ? (
                                <ActivityIndicator size="small" color="white" />
                            ) : (
                                <Text style={{ fontSize: dynamicFontSize(15), color: 'white', fontFamily: 'Sen-Bold' }}>
                                    Cancel
                                </Text>
                            )}
                        </TouchableOpacity>
                    </> :
                        <><CheckCircleIcon height={dynamicSize(100)} width={dynamicSize(100)} color={Colours.PRIMARY} />
                            <Text style={{ marginTop: dynamicSpacing(15), color: Colours.DARKGRAY, fontSize: dynamicFontSize(17), fontFamily: 'Sen-Medium', textAlign: 'center' }}>Your account has been verified.
                                Proceed to complete setup</Text>

                            <TouchableOpacity style={styles.button2}
                                onPress={generateDedicatedVirtualAccount}
                            >
                                {isLoading ? (
                                    <ActivityIndicator size="small" color="white" />
                                ) : (
                                    <Text style={{ fontSize: dynamicFontSize(15), color: 'white', fontFamily: 'Sen-Bold' }}>
                                        Complete Set-up
                                    </Text>
                                )}
                            </TouchableOpacity>
                        </>}

            </View>
        </View>
    )
}

const styles = StyleSheet.create({

    profileContainer2: {
        height: '100%',
        width: '100%',
        padding: dynamicSpacing(30),
    },
    profileHeaderContainer2: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    accDetails: {
        display: 'flex',
        width: '100%',
        padding: dynamicSpacing(10),
        marginTop: dynamicSpacing(10),
        backgroundColor: Colours.PRIMARY_LIGHTER,
        borderRadius: dynamicSize(10),
    },
    userImage2: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderWidth: dynamicSize(2),
        borderColor: 'white',
        borderRadius: dynamicSize(99),
    },
    button2: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: '15%',
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.PRIMARY,
    },

})

export default VerifiedCustomer
